module.exports = __webpack_public_path__ + "static/lslogowh-04bd34a89c7db0b91a25905e03d3cd36.png";